<template>
  <div>
    <div class="d-flex user-center">
      <keep-alive>
      <div class="left-menu">
        <!-- <div class="collapse-btn" @click="isCollapse = !isCollapse"></div> -->
          <el-scrollbar style="height:100%;">
            <el-menu class="el-menu-vertical-demo" 
              :collapse="isCollapse" 
              unique-opened
              :default-active="activeRoute"
              background-color="#363e50" text-color="#fff" active-text-color="#12B2CB">
                <!--导航头部logo-->
                <div class=" header-logo d-center cursor-pointer" @click="$router.push({name:'CenterIndex'})">
                  <img src="/images/public/logo.png" width="50px">
                  <span class="ml-2 text-white h3" v-if="!isCollapse">{{userInfo.cn}}</span>  
                </div>
                <div v-for="item in MenuArr" :key="item.label" class="navigation">
                  <!--多菜单导航-->
                  <el-submenu :index="item.label" :key="item.label" v-if="item.children">
                    <template slot="title">
                      <i :class="['iconfont mr-3 text-white',item.iconClass]" ></i>
                      <span slot="title">{{item.label}}
                      <!--显示数量-->
                      <span class="unread-msg" v-if="waitVerify[item.num]>0">{{waitVerify[item.num]}}</span>
                      </span>
                    </template>
                    <!--子菜单-->
                    <template v-for="childItem in item.children">
                      <el-menu-item :index="hump(childItem)"   :key="childItem.label" @click="toPage(childItem.path)" v-if="!childItem.isGroup">
                            <span class="ml-3">{{childItem.label}}</span>
                            <span class="child-unread-msg" v-if="waitVerify[childItem.num]>0">{{waitVerify[childItem.num]}}</span>
                      </el-menu-item>
                    </template>
                  </el-submenu>
                  <!--单菜单导航-->
                  <el-menu-item :index="hump(item)" @click="toPage(item.path)"  v-else>
                    <i :class="['iconfont mr-3 text-white',item.iconClass]"></i>
                    <span slot="title">
                      <span>{{item.label}}</span>
                      <!--显示数量-->
                      <span class="unread-msg" v-if="waitVerify[item.num]>0">{{waitVerify[item.num]}}</span>
                      <!--显示数量-->
                      <span class="unread-msg" v-if="unReadMsg>0 && item.label==='消息中心'">{{unReadMsg}}</span>
                    </span>
                  </el-menu-item>
                </div>
                <!--退出按钮-->
                <el-menu-item @click="logout" index="安全退出" class="navigation">
                  <i class="iconfont icon-tuichu1 mr-3 text-white"></i>
                  <span slot="title">安全退出</span>
                </el-menu-item>
            </el-menu>
          </el-scrollbar>
      </div>
      </keep-alive>
      <!--右侧显示内容-->
      <div class="d-flex flex-column" style="flex:1;width: 100px;">
        <user-header class="header-logo" v-if="userInfo.type!==99"/>
        <admin-header class="header-logo" v-else/>
        <div class="router-view-home pl-3 pt-3 bg-base">
          <el-scrollbar style="height:100%;">
            <router-view class="pr-3 pb-3" />
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions,mapState } from 'vuex'
import menuArr from './MenuArr/index'
import UserHeader from './UserHeader'
import AdminHeader from './AdminHeader'

export default {
  name: 'UserCenterWrap',
  components: { AdminHeader, UserHeader },
  props: {},
  data() {
    return {
      isCollapse: false,
    };
  },
  computed: {
    ...mapState(['waitVerify','IndexData','userLoginMessage']),
    ...mapGetters(['unReadMsg','storeInfo', 'userInfo','isAdmin','totalVerify', 'isGroup']),
    //判断是否是修改订单
    modify() { return this.$route.query.modify?true : false },
    MenuArr () {
      let hasChildren=[];
      if(this.isAdmin){hasChildren=menuArr.Admin;document.title = `订单雨-管理员用户中心`};
      if(this.storeInfo.level==1){};                    
      if(this.storeInfo.level==2){
        if(this.storeInfo.type==2){
          //采购商-企业
          hasChildren=menuArr.ProcurementEnterprise;
        }else{
          //供应商-酒店
          hasChildren=menuArr.SupplierHotel
        }
      };            
      if(this.storeInfo.level==3&&this.storeInfo.type==3){hasChildren=menuArr.SupplierSales};                    //供应商-销售
      if(this.storeInfo.level==4||this.storeInfo.type==2&&this.storeInfo.level==3){hasChildren=menuArr.ProcurementIndividual};            //采购商-个人
      return hasChildren
    },  
    //高亮
    activeRoute () {
      if (this.$route.name == 'StoreManage') return 'StoreManage?storeType=' + this.$route.query.storeType
      if (this.$route.name == 'UserManage') return 'UserManage?storeType=' + this.$route.query.storeType
      else return this.$route.name
    }
  },
  watch: {
    isCollapse(newVal) {
        if (newVal) {
          $('.left-menu').animate({width:'70px'},400);
        } else {
          $('.left-menu').animate({width:'240px'},400);
        }
    }
  },
  created() {
    if(this.$route.name!='CenterIndex'){
      this.getWaitHandleData();
    }
    
  },
  mounted() {},
  methods: {
    ...mapActions(['logout','getWaitHandleData','getUserIndexData','getBuyWaitData','updateInfo']),
    //高亮
    hump (value) {
      let s = value.path.name
      if (s=='StoreManage') return 'StoreManage' + '?storeType=' + value.path.query.storeType
      if (s=='UserManage') return 'UserManage' + '?storeType=' + value.path.query.storeType
      else return s   
      // this.modify?''//修改订单不高亮导航
    },
    toPage (path) {
      if (this.isGroup && !this.storeInfo.storeId) {
        this.$alert('当前集团旗下门店数量为0，请添加门店或联系客服：0571-89986918', '提示', {
          confirmButtonText: '确定',
          center: true
        }).then(_ => this.$router.push({name:'GroupAddStore',query:{step:1}}));
      } else {
        let s = this.userLoginMessage;
        let num = s.uid||s.id;
        if(num=="") {
          this.updateInfo();
        }  
        this.$router.push(path)
      }
    }
  }
};
</script>
<!--303A56之前背景颜色-->
<style lang="scss" scoped>
  .navigation{
    text-align: left;
  }
  .navigation-icon{
    margin-right: 5px;
  }
    .cursor-pointer{
      background: #363e50 !important; 
    }
    .user-center {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
  }
  .el-menu-item.is-active {
    color: var(--smtc-color-primary) !important;
    .text-white{
      color: var(--smtc-color-primary) !important;
    }

  }
  .left-menu {
    width: 180px !important;
    height: calc(100vh);
    user-select: none;
    background: #363e50;
    position: relative;
  }
  .el-menu {
    border-right: none;
  }
  // .el-menu-vertical-demo {
  //   background-color: #999 !important;
  // }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    min-height: 400px;
  }

  .header-logo {
    height: 100px;
    box-sizing: border-box;
    box-shadow: -3px 0 3px 3px #dddddda8;
    background-color: #fff;
  }

  .router-view-home {
    height: calc(80vh);
    flex: 1;
    overflow: auto;
    position: relative;
  }

  .collapse-btn {
    position: absolute;
    width: 30px;
    height: 30px;
    right: -13px;
    top: calc(45vh);
    background: #363e50;
    z-index: 1;
    cursor: pointer;
    color: #fff;
    writing-mode: vertical-rl;
    font-size: 20px;
    border-radius: 5px;
    text-align: center;
    &:before {
      content: "";
      position: absolute;
      top: -13px;
      left: 0;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 15px solid #363e50;
      border-radius: 5px;
    }
    &:after {
      border-radius: 5px;
      content: "";
      position: absolute;
      bottom: -12px;
      left: 0;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-top: 15px solid #363e50;
    }
  }
  .unread-msg{
    top: 20px;
    left: 145px;
  }
  .child-unread-msg{
    top: 15px;
    left: 137px;
  }
  .iconfont{
    font-size: 16px;
    margin-top: -1px;
    display: inline-block;
  }
</style>
<style>
  .navigation .is-active{
    background: #2b3240 !important;
    position: relative;
  }
  /* .navigation li .is-active::after{
    content: "";
    position: absolute;
    top: 20px;
    right: 12px; 
    width: 2px;
    height: 18px;
    background: var(--smtc-color-primary) !important;
    border-radius: 4px;
  } */
</style>